/*
 * 2026 rack rates for the self-serve flow, transcribed from
 * "CCC 2026 Pricing.xlsm" (v20260407, CONFIDENTIAL).
 *
 * Scrub product pricing has been moved server-side (GET /api/signup/plans and
 * POST /api/signup/build-plan). This file retains the card limit and formatting
 * helpers that are still used by the wizard's plan and payment steps.
 */

/** Fallback only — the server returns the authoritative value via PlansResponse.cardLimit.
 * Must match SignupConstants.MaxChargeAmount on the backend. */
export const CARD_LIMIT = 1000;

/** "1,000,000" / "250" — volumes read better grouped. */
export const fmtVolume = (n: number) => n.toLocaleString("en-US");

/**
 * Money for a rate card: cents only when the rate card has them. $1,554.25 must
 * not become $1,554, and $219 must not become $219.00.
 */
export const fmtMoney = (n: number) =>
  "$" + n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });

/** Overage rates go to three decimals on the sheet ($25.875, $10.35). */
export const fmtRate = (n: number) =>
  "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 3 });
